"use client";

import { useTranslations } from "next-intl";
import type * as React from "react";
import { YellowBox } from "@/components/features/staking/YellowBox";
import { Skeleton } from "@/components/ui/skeleton";
import { formatStakeNumber } from "@/lib/stake/format-number";

interface MetricGridFallbackProps {
  nftCount: number;
  dnmBalanceWei: bigint;
  uvmBalanceWei: bigint;
  isLoading: boolean;
}

export const MetricGridFallback: React.FC<MetricGridFallbackProps> = ({
  nftCount,
  dnmBalanceWei,
  uvmBalanceWei,
  isLoading,
}) => {
  const t = useTranslations("stake");
  if (isLoading) {
    return (
      <div className="grid grid-cols-3 gap-2">
        <Skeleton variant="muted" className="h-20 w-full rounded-lg" />
        <Skeleton variant="muted" className="h-20 w-full rounded-lg" />
        <Skeleton variant="muted" className="h-20 w-full rounded-lg" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-2">
      <YellowBox
        label={t("metricGrid.myNfts")}
        value={formatStakeNumber(nftCount)}
        variant="metric"
      />
      <YellowBox
        label="DNM"
        value={formatStakeNumber(dnmBalanceWei)}
        variant="metric"
      />
      <YellowBox
        label="UVM"
        value={formatStakeNumber(uvmBalanceWei)}
        variant="metric"
      />
    </div>
  );
};
